import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Image from 'src/components/image';
// ----------------------------------------------------------------------

export default function VisitCalendarNoAvailabilities() {
  const { t } = useTranslation();
  return (
    <Stack
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        flex: 1,
      }}
    >
      <Stack gap={1} justifyContent="center" alignItems="center">
        <Image
          sx={{ width: '100%', maxWidth: '110px' }}
          src="/assets/illustrations/laptop_paw.svg"
          alt="illustration"
        />
        <Stack justifyContent="center" alignItems="center">
          <Typography variant="body1" textAlign="center">
            {t('visit.calendarNoSlotsTitle')}
          </Typography>
          <Typography variant="body2" textAlign="center" color="text.secondary">
            {t('visit.calendarNoSlotsHint')}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
